export enum FieldDataType {
    Input = 1,
    Date = 2,
    Text = 3,
    User = 4,
    GUID = 5,
    CaseNote = 6,
    List = 7,
    Lookup = 8,
    Integer = 9,
    Currency = 10,
    DateTime = 11,
    Reference = 12,
    SiteGroup = 13,
    Checkbox = 14,
    Form = 15,
    Link = 16,
    Grid = 17,
    Decimal = 18,
    MultiValueList = 19
}
